<div class="confirmation">
  <h2 mat-dialog-title>Unexpected Error!</h2>
  <p>We've encountered an unexpected error. If the problem continues, 
    please contact our support team at {{phoneNumber$ | async}} for assistance.</p>  
  <div class="btn-group" role="group">
    <button mat-button (click)="closeDialog()">Ok</button>
  </div>
</div>